module.exports = __webpack_public_path__ + "img/dark-poll.ad836ad1.svg";